(function () {
  'use strict';

  /* @ngdoc object
   * @name share
   * @description
   *
   */
  angular
    .module('share', [
      'ui.router',
      'ui.bootstrap'
    ]);
}());
